import {ArrowIndicatorIcon} from '@/_application/icons/arrow-indicator';
import {FilterPriceSlider} from '@/_application/modules/categories/components/category-filter/category-filter-price/filter-price-slider';
import {Popover, Transition} from '@headlessui/react';
import {AggregationOption} from '__generated__/__types__';
import cn from 'classnames';
import {isNaN} from 'lodash';
import {useTranslation} from 'next-i18next';
import {Fragment, useEffect, useState} from 'react';
import React from 'react';
interface IProps {
    label: string;
    options: AggregationOption[];
    onSave?: (value: string[] | string) => void;
    defaultValue?: number[];
}

function CategoryFilterPrice({label, options, defaultValue, onSave}: Readonly<IProps>) {
    const {t} = useTranslation();
    const {min, max} = options.reduce(
        (acc: {min: number; max: number}, option) => {
            const numericValue = Number(option?.value);
            return {
                min: Math.min(acc.min, numericValue),
                max: Math.max(acc.max, numericValue),
            };
        },
        {
            min: 0,
            max: 0,
        },
    );

    const adjustedMax = max + 100000;

    const [values, setValues] = useState<number[] | number>([]);

    const handleChangeSlider = (values: number[] | number) => {
        if (
            (Array.isArray(values) && values[0] === 0 && values[1] === 0) ||
            (typeof values === 'number' && values === 0)
        ) {
            return;
        }
        setValues(values);
    };

    const handleSave = () => {
        if (onSave) {
            if (Array.isArray(values) && values[0] === min && values[1] === adjustedMax) {
                onSave([]);
                return;
            }
            const parseValues = Array.isArray(values) ? values.map(String) : String(values);
            onSave(parseValues);
        }
    };
    const handleReset = () => {
        setValues([min, adjustedMax]);
    };

    useEffect(() => {
        const initialValue =
            isNaN(defaultValue?.at(0)) || isNaN(defaultValue?.at(1)) ? [min, adjustedMax] : defaultValue;
        setValues(initialValue as number[]);
    }, [defaultValue, adjustedMax, min]);

    return (
        <Popover as="div" className="relative z-15">
            {({open}) => (
                <>
                    <Popover.Button
                        className={cn(
                            'relative flex h-[42px] w-auto cursor-pointer items-center justify-between gap-1 rounded-full border-none px-[15px] font-medium outline-0 transition duration-150 hover:bg-KPZ_Yellow hover:text-primary',
                            {
                                'bg-white text-primary': !open,
                                'bg-KPZ_Blue-Dark text-white': open,
                            },
                        )}>
                        {label}
                        <ArrowIndicatorIcon
                            className={cn('h-[20px] w-[20px] font-bold transition-all duration-300', {
                                '-rotate-180': open,
                            })}
                        />
                    </Popover.Button>
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95">
                        <Popover.Panel className="absolute left-0 mt-1 w-[500px] origin-top-right rounded-[14px] bg-white p-5 shadow-[rgba(0,0,0,0.24)_0px_3px_8px] focus:outline-none">
                            <div className="px-3 py-2">
                                <p className="mb-[10px] text-center font-normal text-blue-800">
                                    {t('text-choose-price')}
                                </p>
                                {/*<FilterPriceSlider min={min} max={max} step={10000} value={values} onChange={handleChangeSlider} />*/}
                                <FilterPriceSlider
                                    min={min}
                                    max={adjustedMax}
                                    step={10000}
                                    value={values}
                                    onChange={handleChangeSlider}
                                />
                                <div className="mt-[10px] flex items-center justify-between">
                                    {Array.isArray(values) && (
                                        <>
                                            <p>
                                                {t('text-from')} {values[0]?.toLocaleString('vi-VN')} đ
                                            </p>
                                            <p>
                                                {t('text-to')} {values[1]?.toLocaleString('vi-VN')} đ
                                            </p>
                                        </>
                                    )}
                                </div>
                            </div>

                            <div className="mt-5 flex flex-row items-center justify-center gap-6 font-bold">
                                <button
                                    aria-label="Xóa tùy chọn đã chọn"
                                    className="h-[38px] w-[180px] rounded-full border-2 border-solid border-KPZ_Gray-04 text-KPZ_Gray-04 transition-opacity hover:opacity-90"
                                    onClick={handleReset}>
                                    Bỏ chọn
                                </button>
                                <button
                                    aria-label="Lưu kết quả lọc"
                                    className="h-[38px] w-[180px] rounded-full bg-KPZ_Cam text-white transition-colors hover:bg-orange-500/90"
                                    onClick={handleSave}>
                                    Xem kết quả
                                </button>
                            </div>
                        </Popover.Panel>
                    </Transition>
                </>
            )}
        </Popover>
    );
}

export default CategoryFilterPrice;
